'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.propEnhancers = exports.propValidators = exports.propAliases = exports.propTypes = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _getCss = require('../get-css');

var _getCss2 = _interopRequireDefault(_getCss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = exports.propTypes = {
  listStyle: _propTypes2.default.string,
  listStyleType: _propTypes2.default.string,
  listStyleImage: _propTypes2.default.string,
  listStylePosition: _propTypes2.default.string
};

var propAliases = exports.propAliases = {};

var propValidators = exports.propValidators = {};

var _listStyle = {
  className: 'ls',
  cssName: 'list-style',
  jsName: 'listStyle',
  complexValue: true
};
var _listStyleType = {
  className: 'ls-typ',
  cssName: 'list-style-type',
  jsName: 'listStyleType'
};
var _listStyleImage = {
  className: 'ls-img',
  cssName: 'list-style-image',
  jsName: 'listStyleImage',
  complexValue: true
};
var _listStylePosition = {
  className: 'ls-pos',
  cssName: 'list-style-position',
  jsName: 'listStylePosition',
  safeValue: true
};

var propEnhancers = exports.propEnhancers = {
  listStyle: function listStyle(value) {
    return (0, _getCss2.default)(_listStyle, value);
  },
  listStyleType: function listStyleType(value) {
    return (0, _getCss2.default)(_listStyleType, value);
  },
  listStyleImage: function listStyleImage(value) {
    return (0, _getCss2.default)(_listStyleImage, value);
  },
  listStylePosition: function listStylePosition(value) {
    return (0, _getCss2.default)(_listStylePosition, value);
  }
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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